import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import {
  GridLegacy as Grid,
  Paper,
  Typography,
  ListItem,
  ListItemButton,
  ListItemText,
  Button,
  ListSubheader,
  IconButton,
} from '@mui/material';
import { Edit } from '@mui/icons-material';
import { FixedSizeList } from 'react-window';
import BorderBox from '../../BorderBox';

const LocationRelationshipsCard = ({
  loc,
  onEditLocationTargets,
  onEditEquipmentTargets,
  locationsByName,
  onUpdateLocation,
  onDeleteLocation,
}) => {
  const targetsHeight = useMemo(
    () => Math.min(225, Math.max(100, (loc.feeds_equipment?.length ?? 0) * 32)),
    [loc.feeds_equipment]
  );

  const children = useMemo(() => loc.contains_locations.concat(loc.contains_equipment), [loc]);

  function renderRow(props) {
    const { index, style } = props;
    const child = children[index];

    return (
      <ListItem style={style} key={index} component="div" disablePadding>
        <ListItemButton sx={{ height: '32px' }}>
          <Grid container columnSpacing={4}>
            <Grid item xs={4}>
              <ListItemText primary={child} />
            </Grid>
            <Grid item xs={5}>
              <ListItemText primary={child in locationsByName ? 'Location' : 'Equipment'} />
            </Grid>
          </Grid>
        </ListItemButton>
      </ListItem>
    );
  }

  return (
    <Grid item>
      <Paper elevation={3}>
        <Grid container rowSpacing={1} direction="column" alignItems="stretch" pr={2} pl={2} pb={1}>
          <Grid item container direction="row" columnSpacing={2}>
            <Grid item>
              <Typography gutterBottom variant="h5" component="div">
                {loc.name}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => onUpdateLocation(loc)} size="small">
                <Edit />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item container>
            <Grid item container xs={4} direction="row" alignItems="center" alignContent="start">
              <Grid item container pr={2} xs={5} justifyContent="flex-end">
                <Typography variant="subtitle2" fontWeight={500} fontSize="1.1rem">
                  Location Type
                </Typography>
              </Grid>
              <Grid item xs={7}>
                {loc.type ?? 'N/A'}
              </Grid>
            </Grid>

            <Grid item xs>
              <BorderBox title="Target Location">
                <ListSubheader sx={{ height: '32px' }}>
                  <Grid container display="row">
                    <Grid item xs={4}>
                      Name
                    </Grid>
                    <Grid item xs={5}>
                      Type
                    </Grid>
                  </Grid>
                </ListSubheader>
                <FixedSizeList
                  height={targetsHeight}
                  itemSize={32}
                  itemCount={children?.length || 0}
                  overscanCount={5}
                >
                  {renderRow}
                </FixedSizeList>
              </BorderBox>
            </Grid>
          </Grid>
          <Grid item container direction="row" justifyContent="flex-end" columnSpacing={2}>
            <Grid item>
              <Button
                color="info"
                variant="contained"
                sx={{ wordWrap: 'break-word', marginRight: '10px' }}
                onClick={() => onEditLocationTargets(loc)}
              >
                Edit CONTAINS Locations
              </Button>
              <Button
                color="info"
                variant="contained"
                sx={{ wordWrap: 'break-word', marginRight: '10px' }}
                onClick={() => onEditEquipmentTargets(loc)}
              >
                Edit CONTAINS Equipment
              </Button>
              <Button
                color="error"
                variant="outlined"
                sx={{ wordWrap: 'break-word' }}
                onClick={() => onDeleteLocation(loc)}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const mapStateToProps = (state, { equipment }) => ({
  equipment,
  promotedEquipmentById: state.entities.equipment.byId ?? {},
});

export default connect(mapStateToProps)(LocationRelationshipsCard);
